import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  pathname: string;
}

const ScrollToTopHelper = () => {
  const { pathname } = useLocation();
  return <ScrollToTop pathname={pathname} />;
};

function ScrollToTop({ pathname }: ScrollToTopProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export { ScrollToTopHelper as ScrollToTop };
